var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class TclIr {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.irConnector = '1';
        this.irCodes = {
            av: ',1,38000,1,1,342,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,21,21,64,21,21,21,21,21,64,21,21,21,21,21,21,21,64,21,21,21,64,21,64,21,21,21,64,21,64,21,1437,342,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,21,21,64,21,21,21,21,21,64,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,21,21,64,21,21,21,1240',
            hdmi1: ',1,38000,1,1,343,172,21,21,21,65,21,21,21,65,21,21,21,65,21,65,21,65,21,65,21,65,21,65,21,21,21,21,21,21,21,65,21,65,21,65,21,21,21,21,21,21,21,21,21,65,21,21,21,21,21,21,21,65,21,65,21,65,21,65,21,21,21,65,21,65,21,1437,343,172,21,21,21,65,21,21,21,65,21,21,21,65,21,65,21,65,21,65,21,65,21,65,21,21,21,21,21,21,21,65,21,65,21,65,21,21,21,21,21,21,21,21,21,65,21,21,21,65,21,21,21,65,21,65,21,65,21,65,21,21,21,65,21,21,21,1240',
            hdmi2: ',1,38000,1,1,342,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,21,21,21,21,64,21,21,21,21,21,64,21,21,21,64,21,64,21,64,21,21,21,64,21,64,21,1437,342,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,21,21,21,21,21,21,64,21,21,21,64,21,64,21,21,21,64,21,64,21,64,21,21,21,64,21,21,21,1240',
            hdmi3: ',1,38000,1,1,343,171,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,21,21,21,21,21,21,21,21,64,21,64,21,64,21,21,21,64,21,64,21,1437,343,171,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,21,21,64,21,21,21,21,21,64,21,64,21,64,21,21,21,64,21,21,21,1240',
            tv: ',1,38000,1,1,342,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,21,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,1437,342,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,64,21,21,21,64,21,21,21,64,21,21,21,64,21,21,21,21,21,64,21,21,21,64,21,21,21,64,21,21,21,1240',
            netflix: ',1,38000,1,69,342,171,20,20,20,64,20,20,20,64,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,64,20,64,20,20,20,64,20,20,20,20,20,64,20,20,20,64,20,20,20,64,20,20,20,64,20,64,20,20,20,64,20,20,20,64,20,1442,342,171,20,20,20,64,20,20,20,64,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,64,20,64,20,20,20,64,20,20,20,20,20,64,20,20,20,64,20,64,20,64,20,20,20,64,20,64,20,20,20,64,20,20,20,20,20,1442',
            powerOff: ',1,38000,1,1,343,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,64,21,21,21,21,21,64,21,64,21,64,21,1437,343,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,21,21,64,21,64,21,64,21,64,21,21,21,21,21,64,21,64,21,21,21,1240',
            powerOn: ',1,38000,1,1,343,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,64,21,21,21,64,21,21,21,21,21,21,21,64,21,21,21,21,21,64,21,21,21,64,21,64,21,64,21,1437,343,172,21,21,21,64,21,21,21,64,21,21,21,64,21,64,21,64,21,64,21,64,21,64,21,21,21,21,21,21,21,64,21,64,21,21,21,64,21,64,21,21,21,64,21,21,21,21,21,64,21,64,21,21,21,21,21,64,21,21,21,64,21,64,21,21,21,1240',
            volumeDown: ',1,38000,1,69,342,171,20,20,20,64,20,20,20,64,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,64,20,64,20,20,20,20,20,20,20,20,20,64,20,20,20,20,20,20,20,64,20,64,20,64,20,64,20,20,20,64,20,64,20,64,20,1443,342,171,20,20,20,64,20,20,20,64,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,64,20,64,20,20,20,20,20,20,20,20,20,64,20,20,20,20,20,64,20,64,20,64,20,64,20,64,20,20,20,64,20,64,20,20,20,1443',
            volumeUp: ',1,38000,1,69,342,171,20,20,20,64,20,20,20,64,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,64,20,64,20,64,20,64,20,1442,342,171,20,20,20,64,20,20,20,64,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,64,20,64,20,64,20,64,20,64,20,64,20,20,20,20,20,20,20,64,20,20,20,20,20,20,20,20,20,64,20,64,20,64,20,20,20,1442',
        };
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: `ping`,
                next: /ERR(?:\s*|_)\d+/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const cmd = this.buildCommand(`${power ? 'powerOn' : 'powerOff'}`);
                yield this.socket.send(cmd, /completeir,\d:\d|busyIR/i, tags);
                if (!power)
                    yield this.socket.send(cmd, /completeir,\d:\d/i, tags); // confirm power off
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 4000);
                return power;
            }),
        };
        this.videoInput = {
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(this.buildCommand(`${code}`), /completeir,\d:\d|busyIR/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 2000);
                return code;
            }),
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    if (this.socket.hasCommands())
                        return;
                    yield this.socket.send('ping', /ERR(?:\s*|_)\d+/i, ['poll']);
                }),
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.irConnector = (_b = (_a = config.ir) === null || _a === void 0 ? void 0 : _a.connector) !== null && _b !== void 0 ? _b : '1';
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    buildCommand(name) {
        return `sendir,1:${this.irConnector}${this.irCodes[name]}`;
    }
}
// static properties
TclIr.driverType = 'socketDriver';
TclIr.key = '-M5gTSZeEo2Q96aBcfNC';
TclIr.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r'],
    },
    sendTerminator: '\r',
};
TclIr.socketOptions = [
    Object.assign(Object.assign({}, TclIr.baseSocketOptions), { port: 4998 }),
];
